import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { apiGet } from '../lib/api';
import Reveal from '../components/Reveal';

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => {
    apiGet('/brands').then(setBrands).catch(() => {});
  }, []);

  return (
    <div className="bg-cream min-h-screen">
      <div className="bg-forest noise relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <p className="font-mono text-[11px] uppercase tracking-widest2 text-flame mb-3">Shop by brand</p>
          <h1 className="font-display font-extrabold uppercase tracking-tight text-cream text-4xl sm:text-5xl leading-none">
            The big six,<br />covered.
          </h1>
          <p className="text-cream/50 text-sm mt-4 max-w-xl">
            We stock fitment-matched parts for the six most-run tractor brands in America. We are an
            independent supplier and are not affiliated with, sponsored or authorized by any manufacturer.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-2 gap-6">
        {brands.map((b, i) => (
          <Reveal key={b.id} delay={(i % 2) * 0.08}>
            <div className="group bg-white border border-emerald-950/10 rounded-3xl p-8 h-full hover:shadow-[0_20px_50px_-20px_rgba(11,43,26,0.35)] transition-shadow">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h2 className="font-display font-extrabold uppercase tracking-tight text-forest text-4xl group-hover:text-flame transition-colors">
                    {b.name}
                  </h2>
                  <p className="text-sub text-sm mt-1">{b.tagline}</p>
                </div>
                <span className="font-mono text-[11px] uppercase tracking-wide text-flame bg-flame/10 rounded-full px-3 py-1.5 shrink-0">
                  {b.product_count} parts
                </span>
              </div>
              <div className="flex flex-wrap gap-1.5 mt-6">
                {b.models.map((m) => (
                  <Link
                    key={m}
                    to={`/shop?brand=${encodeURIComponent(b.name)}&search=${encodeURIComponent(m)}`}
                    data-testid={`brand-model-chip-${b.slug}-${m.replace(/\s+/g, '-')}`}
                    className="font-mono text-[11px] text-ink border border-emerald-950/15 rounded-full px-3 py-1.5 hover:bg-forest hover:text-cream hover:border-forest transition"
                  >
                    {m}
                  </Link>
                ))}
              </div>
              <Link
                to={`/shop?brand=${encodeURIComponent(b.name)}`}
                data-testid={`brand-shop-link-${b.slug}`}
                className="mt-6 inline-flex items-center gap-2 font-display font-semibold uppercase tracking-wide text-forest hover:text-flame transition"
              >
                Shop all {b.name} parts <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
